module.exports = __webpack_public_path__ + "fonts/Inter-700-greek-ext66.2d64d8a.woff2";